import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--color-primary);
  text-decoration: none;
`;

const LogoIcon = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background-color: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 1.2rem;
  color: white;
  font-weight: 700;
`;

const LogoText = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`;

const Logo = () => {
  return (
    <LogoContainer to="/">
      <LogoIcon>KL</LogoIcon>
      <LogoText>KriegerLabs</LogoText>
    </LogoContainer>
  );
};

export default Logo;